<template>
  <div id="mapGetListWrap">
    <div id="mapgetSelect" v-if="!hideSelect">
      <myselect simble @history="reHistory" style="padding-top: 0"></myselect>
    </div>
    <div id="slidermap">
      <div>
        <h4 v-if="path1.length > 0">
          拖动滑块进行裁剪，当前裁剪{{ path1[0].gpsTime1 }}到{{
            path1[path1.length - 1].gpsTime1
          }}，共{{ path1.length }}个点
        </h4>
        <a type="primary" @click="save">获取裁剪结果</a>
      </div>
      <Slider @on-change="change" v-model="percent" range></Slider>
    </div>
    <div id="mapGetList"></div>
  </div>
</template>
<script>
var map;
var polyline;
var storePath = [];
var pointMarkers = [];
let orgPath = []; //原始轨迹，用来纠偏
import myselect from "../locus/select.vue";
import axios from "axios";
export default {
  props: ["hideSelect"],
  components: { myselect },
  data() {
    return {
      center: [114, 24],
      path: [],
      path1: [],
      percent: [0, 100],
      a:123
    };
  },
  methods: {
    reHistory(x) {
      switch (x.val) {
        case 0:
          let params = {
            deviceNo: x.deviceNo,
            returnCoord: 2, //返回坐标系（1-WGS84，2-GCJ-02，3-BD-09）,可用值:1,2,3
            endTime: x.end.getTime(),
            startTime: x.start.getTime(),
          };
          this.utils.loading(this, "加载中");
          this.axios({
            method: "post",
            url: this.axios.lbs + "/locus/getPlyLocus",
            data: params,
          }).then((res) => {
            this.$Spin.hide(); //关闭加载
            var data = res.data.data.dataList;
            this.showData(data);
          });
          break;
      }
    },
    showData(data) {
      if (data.length == 0) {
        this.$Message.error("无轨迹");
        return;
      }
      storePath = [];
      for (let i = 0; i < data.length; i++) {
        data[i].tms = data[i].gpsTime / 1000;
        var arr = [data[i].returnX, data[i].returnY];
        storePath.push(arr);
      }
      orgPath = data;
      this.path = storePath;
      this.path1 = orgPath;
      this.drawDefaulline();
    },
    loadMap() {
      map = new AMap.Map("mapGetList", {
        resizeEnable: true,
        center: this.center,
        zoom: 10,
      });
    },
    lineClear() {
      var polyArr = map.getAllOverlays("polyline");
      map.remove(polyArr);
    },
    drawDefaulline() {
      map.clearMap();
      polyline = new AMap.Polyline({
        path: this.path,
        isOutline: true,
        outlineColor: "#ffeeff",
        borderWeight: 4,
        strokeColor: "#3366FF",
        strokeOpacity: 1,
        strokeWeight: 4,
        // 折线样式还支持 'dashed'
        strokeStyle: "solid",
        // strokeStyle是dashed时有效
        strokeDasharray: [10, 5],
        lineJoin: "round",
        lineCap: "round",
        zIndex: 50,
      });
      this.startEndPoint();
      polyline.setMap(map);
      // 缩放地图到合适的视野级别
      map.setFitView([polyline]);
    },
    change(v) {
      var length = storePath.length;
      var start = Math.floor((length * v[0]) / 100);
      var end = Math.floor((length * v[1]) / 100);
      this.path = [];
      this.path1 = []; //画图过后，path被改成地图定义的数组格式了，这个path1是不会被改，因为他不参与地图绘制。
      for (let i = start; i < end; i++) {
        this.path.push(storePath[i]);
        this.path1.push(orgPath[i]);
      }
      this.drawDefaulline();
    },
    startEndPoint(v) {
      map.remove(pointMarkers);
      var m = 0;
      for (var i = 0, marker; i < this.path.length; i++) {
        if (i == 0 || i == this.path.length - 1) {
          i == 0 ? (m = 0) : (m = 1);
          var icon = new AMap.Icon({
            size: new AMap.Size(100, 100), // 图标尺寸
            image: "static/" + m + ".gif", // Icon的图像
            imageOffset: new AMap.Pixel(0, 0), // 图像相对展示区域的偏移量，适于雪碧图等
            imageSize: new AMap.Size(24, 32), // 根据所设置的大小拉伸或压缩图片
          });
          marker = new AMap.Marker({
            position: this.path[i],
            icon: icon,
            map: map,
            offset: new AMap.Pixel(-12, -36),
          });
          pointMarkers.push(marker);
        }
      }
    },
    save() {
      this.$emit("path", this.path);
      this.$emit("path1", this.path1);
    },
  },
  mounted() {
    this.loadMap();
  },
};
</script>
<style lang="">
#mapGetListWrap {
  width: 100%;
  height: 100%;
  position: relative;
}
#mapgetSelect {
  width: 280px;
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 2;
  background: white;
}
#slidermap {
  padding: 15px 15px 0 15px;
  width: 100%;
  position: absolute;
  left: 0;
  bottom: 0;
  background: white;
  z-index: 2;
}
#slidermap>div {
  display: flex;
}
#slidermap>div>h4 {
  margin-right: auto;
}
#mapGetList {
  width: 100%;
  height: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/map/mapGetList.vue